// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-03-18T17:47:05.191Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const AgreementListView = lazy(() => import('@/procurement/AgreementListView').then(m => ({ default: m.AgreementListView })));
const AgreementDetailView = lazy(() => import('@/procurement/AgreementDetailView').then(m => ({ default: m.AgreementDetailView })));
const InboundMeasuringTicketListView = lazy(() => import('@/procurement/InboundMeasuringTicketListView').then(m => ({ default: m.InboundMeasuringTicketListView })));
const InboundMeasuringTicketDetailView = lazy(() => import('@/procurement/InboundMeasuringTicketDetailView').then(m => ({ default: m.InboundMeasuringTicketDetailView })));
const LoadObservationListView = lazy(() => import('@/procurement/LoadObservationListView').then(m => ({ default: m.LoadObservationListView })));
const LoadObservationDetailView = lazy(() => import('@/procurement/LoadObservationDetailView').then(m => ({ default: m.LoadObservationDetailView })));
const OrganizationListView = lazy(() => import('@/procurement/OrganizationListView').then(m => ({ default: m.OrganizationListView })));
const OrganizationDetailView = lazy(() => import('@/procurement/OrganizationDetailView').then(m => ({ default: m.OrganizationDetailView })));
const ProjectListView = lazy(() => import('@/procurement/ProjectListView').then(m => ({ default: m.ProjectListView })));
const ProjectDetailView = lazy(() => import('@/procurement/ProjectDetailView').then(m => ({ default: m.ProjectDetailView })));
const SupplierListView = lazy(() => import('@/procurement/SupplierListView').then(m => ({ default: m.SupplierListView })));
const SupplierDetailView = lazy(() => import('@/procurement/SupplierDetailView').then(m => ({ default: m.SupplierDetailView })));
const WorkorderListView = lazy(() => import('@/procurement/WorkorderListView').then(m => ({ default: m.WorkorderListView })));
const WorkorderDetailView = lazy(() => import('@/procurement/WorkorderDetailView').then(m => ({ default: m.WorkorderDetailView })));

/**
 * Procurement Module Routes
 */
export const procurementRoutes = [
{ path: '/procurement/agreements',
element: <Suspense><AgreementListView /></Suspense> },
{ path: '/procurement/agreements/:id',
element: <Suspense><AgreementDetailView /></Suspense> },
{ path: '/procurement/inboundmeasuringtickets',
element: <Suspense><InboundMeasuringTicketListView /></Suspense> },
{ path: '/procurement/inboundmeasuringtickets/:id',
element: <Suspense><InboundMeasuringTicketDetailView /></Suspense> },
{ path: '/procurement/loadobservations',
element: <Suspense><LoadObservationListView /></Suspense> },
{ path: '/procurement/loadobservations/:id',
element: <Suspense><LoadObservationDetailView /></Suspense> },
{ path: '/procurement/organizations',
element: <Suspense><OrganizationListView /></Suspense> },
{ path: '/procurement/organizations/:id',
element: <Suspense><OrganizationDetailView /></Suspense> },
{ path: '/procurement/projects',
element: <Suspense><ProjectListView /></Suspense> },
{ path: '/procurement/projects/:id',
element: <Suspense><ProjectDetailView /></Suspense> },
{ path: '/procurement/suppliers',
element: <Suspense><SupplierListView /></Suspense> },
{ path: '/procurement/suppliers/:id',
element: <Suspense><SupplierDetailView /></Suspense> },
{ path: '/procurement/workorders',
element: <Suspense><WorkorderListView /></Suspense> },
{ path: '/procurement/workorders/:id',
element: <Suspense><WorkorderDetailView /></Suspense> }
];
